import log, { LogLevelDesc } from 'loglevel';
import environment from '../EnvironmentProvider/EnvironmentProvider';

log.setDefaultLevel(environment.logLevel as LogLevelDesc);

export default log;
